import type { VariantProps } from 'class-variance-authority'

import { Button as ButtonPrimitive } from '@base-ui/react/button'
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const buttonVariants = cva(
    "group/button inline-flex shrink-0 items-center justify-center gap-2.5 rounded-sm border border-transparent text-[0.72rem] font-semibold uppercase tracking-[0.2em] whitespace-nowrap transition-[background-color,border-color,color,opacity] duration-300 outline-none select-none focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-brass disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground hover:bg-brass-light',
                outline: 'border-brass/55 bg-transparent text-foreground hover:border-brass hover:text-brass',
                secondary: 'border-ivory/15 bg-graphite text-foreground hover:border-ivory/30',
                ghost: 'text-foreground hover:bg-accent hover:text-brass',
                destructive: 'bg-destructive/15 text-destructive hover:bg-destructive/25',
                link: 'h-auto rounded-none px-0 text-brass underline-offset-8 hover:underline'
            },
            size: {
                default: 'h-12 px-7',
                sm: 'h-10 px-5 text-[0.68rem]',
                lg: 'h-14 px-9',
                icon: 'size-11',
                'icon-sm': 'size-9'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
)

function Button({
    className,
    variant = 'default',
    size = 'default',
    ...props
}: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
    return (
        <ButtonPrimitive
            data-slot='button'
            className={cn(buttonVariants({ variant, size, className }))}
            {...props}
        />
    )
}

export { Button, buttonVariants }
